// Экран AI Paralegal (/ai-paralegal) скрыт, если арендатор выключил его признаком.
// Два признака разведены: `ai_paralegal` гейтит ещё и разбор почты на бэкенде
// (email_tasks.py), поэтому ELN не может выключить экран им — почта встала бы.
// `ai_paralegal_screen: false` прячет только экран: 17.10.2026 на ELN он показывал
// иммиграционный консилиум Fitenko Law (Екатерина Фитенко, USCIS).
export const paralegalSkryt = (features) =>
  !!features && (features.ai_paralegal === false || features.ai_paralegal_screen === false);
